export default "__VITE_ASSET__WarxIEU7__"